import Vue from 'vue'
import { Button ,Form,FormItem,Cascader, CascaderPanel,DatePicker,Input,Loading,Carousel} from 'element-ui'


// Vue.use(Button)
// Vue.use(Form)
// Vue.use(FormItem)
Vue.use(CascaderPanel)
Vue.use(Cascader)
Vue.use(Loading)
Vue.use(Carousel)
// Vue.use(DatePicker)
// Vue.use(Input)
